import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { env, isConfigured } from "./env";

let client: SupabaseClient | null = null;

/** The browser client: anon key plus the signed-in user's session. Row-level security does the rest. */
export function getSupabase(): SupabaseClient {
  if (!isConfigured) throw new Error("VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are not set.");
  if (!client) {
    client = createClient(env.supabaseUrl, env.supabaseAnonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: "pkce" },
    });
  }
  return client;
}
